module.exports = __webpack_public_path__ + "static/img/index3.70d5d5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index3.png
// module id = CxP/
// module chunks = 1